import View_1 from "./view_1"
import View_2 from "./view_2"
import View_3 from "./view_3"
import View_4 from "./view_4"
import View_5 from "./view_5"

import style from './index.css';
import { BrowserRouter as Router, Route, Switch, HashRouter } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { Redirect } from 'react-router-dom';
import { Layout, Menu, Breadcrumb, Row, Col, Card, Space, PageHeader } from 'antd';
import { useState, useEffect, useRef } from 'react';
import SubMenu from "antd/lib/menu/SubMenu"
import { HomeOutlined, LineChartOutlined, UserOutlined } from "@ant-design/icons"
import map from "./graph/ihpp_map_MRT.jpeg";
import Homepage from "./homepage"
import IHPP_icon from "./graph/IHPP_logo.png";
import BOD_icon from "./graph/BOD_logo.png";
import MOPH_icon from "./graph/MOPH_logo.png";
import BORA_icon from "./graph/BORA_logo.png";
import { parse } from 'papaparse';
import { Collapse } from 'antd';

import csv_4 from './data/view_1/view1_week_country.csv';

import { useDispatch, useSelector } from 'react-redux';
import { setLoadStatus } from './redux/data_view1';

const { Header, Content, Footer } = Layout;

var screen_width_fac = 0.5;
var screen_height_fac = 0.65;

const Home = () => {

    const { Panel } = Collapse;
    const dispatch = useDispatch();
    const loadStatus = useSelector((state) => state.data_view1.dataState.loadStatus);
    // const [loadStatus, setLoadStatus] = useState(false);

    const [getDataState, setGetDataState] = useState(false);
    const [latestMonth, setLastestMonth] = useState(null);
    const [latestWeek, setLastestWeek] = useState(null);
    const [latestYear, setLastestYear] = useState(null);

    let viewSelectedDefaulted;
    const path = window.location.href;
    const view = path.substring(path.length-5,path.length);

    if(view === 'view1'){
        viewSelectedDefaulted = ['2'];
    } else if(view === 'view2'){
        viewSelectedDefaulted = ['3'];
    } else if(view === 'view3'){
        viewSelectedDefaulted = ['4'];
    } else if(view === 'view4'){
        viewSelectedDefaulted = ['5'];
    } else if(view === 'view5'){
        viewSelectedDefaulted = ['6'];
    } else if(view === 'outus'){
        viewSelectedDefaulted = ['7'];
    } else {
        viewSelectedDefaulted = ['1'];
    }
    
    const scrollWithOffset = (el,loadStatus,view) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        // const yOffset = -100; 
        var yOffset;
        if(loadStatus === false){
            if(view === 0){
                window.scrollTo({ top: yCoordinate }); 
            } else if(view === 2){
                yOffset = 100; 
                window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
            } else if (view === 3){
                yOffset = 300; 
                window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
            } else if (view === 4){
                yOffset = 500; 
                window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
            } else if (view === 5){
                yOffset = 2000; 
                window.scrollTo({ top: yCoordinate }); 
            }
            dispatch(setLoadStatus(true));
        } else {
            yOffset = -100; 
            window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
        }
        // window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
    }

    useEffect(() => {
        const abortCont = new AbortController();

        function streamResolve(url) {
            return fetch(url, {mode: 'cors', signal: abortCont.signal }).then(response => response.body)
            .then(rb => {
                const reader = rb.getReader();
              
                return new ReadableStream({
                  start(controller) {
                    // The following function handles each data chunk
                    function push() {
                      // "done" is a Boolean and value a "Uint8Array"
                      reader.read().then( ({done, value}) => {
                        // If there is no more data to read
                        if (done) {
                          console.log('homepage done', done);
                          controller.close();
                          return;
                        }
                        // Get the data and send it to the browser via the controller
                        controller.enqueue(value);
                        // Check chunks by logging to the console
                        //console.log(done, value);
                        push();
                      })
                    }
              
                    push();
                  }
                });
              })
              .then(stream => {
                // Respond with our stream
                return new Response(stream, { headers: { "Content-Type": "application/json" } });
              })
              .then(result => {
                // Do things with result
                return result;
              });
    
          }

        Promise.all([
            streamResolve(csv_4).then(resp => resp.text()),
        ])
            .then(data => {
                const jsonData = [];
                data.forEach((d,i) => {
                    let d_parse = parse(d,{header: true, dynamicTyping: true, skipEmptyLines:true});
                    jsonData.push(d_parse.data);
                })
                const lastestData = jsonData[0][jsonData[0].length-1];
                setLastestMonth(lastestData.DMON);
                setLastestWeek(lastestData.DWEEK);
                setLastestYear(lastestData.DYEAR);
                setGetDataState(true);
            }).catch(err => {
                if(err.name === 'AbortError'){
                    console.log('fetch aborted');
                }
            });
    }, []);

    return ( 
    <HashRouter>
        <Layout className="layout">
            <Header className="headerBar" style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
                <div className='MOPH_logo'>
                    <Link to="/home">
                        <img src={MOPH_icon} alt="MOPH logo"/>
                    </Link>
                </div>
                <div className='BORA_logo'>
                    <Link to="/home">
                        <img src={BORA_icon} alt="BORA logo"/>
                    </Link>
                </div>
                <div className='IHPP_logo'>
                    <Link to="/home">
                        <img src={IHPP_icon} alt="IHPP logo"/>
                    </Link>
                </div>
                <div className='BOD_logo'>
                    <Link to="/home">
                        <img src={BOD_icon} alt="BOD logo"/>
                    </Link>
                </div>
                <Menu theme="light" mode="horizontal" defaultSelectedKeys={viewSelectedDefaulted} breakpoint="md" collapsedWidth="0">
                    <Menu.Item icon={<HomeOutlined />} key="1">
                        <Link to="/home#home" scroll={el => scrollWithOffset(el,loadStatus,0)}>
                            หน้าแรก
                        </Link>
                    </Menu.Item>
                    <SubMenu class="submenu-bar" key="sub1" icon={<LineChartOutlined />} title="กราฟทางสถิติ">
                        <Menu.Item class="submenu-bar-item" key="2">
                            <Link to="/graphs&map#" scroll={el => scrollWithOffset(el,loadStatus,1)}>
                                การตายส่วนเกินตามเวลา
                            </Link>
                        </Menu.Item>
                        <Menu.Item class="submenu-bar-item" key="3">
                            <Link to="/graphs&map#graph2" scroll={el => scrollWithOffset(el,loadStatus,2)}>
                                การเปรียบเทียบจำนวนตายในช่วงปีที่มีการระบาดของโรคโควิด-19 และ จำนวนตายที่คาดประมาณ
                            </Link>
                        </Menu.Item>
                        <Menu.Item class="submenu-bar-item" key="4">
                            <Link to="/graphs&map#graph3" scroll={el => scrollWithOffset(el,loadStatus,3)}>
                                การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ
                            </Link>
                            {/* <a href="/view3">
                                การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ
                            </a> */}
                        </Menu.Item>
                        <Menu.Item class="submenu-bar-item" key="5">
                            <Link to="/graphs&map#graph4" scroll={el => scrollWithOffset(el,loadStatus,4)}>
                                การตายส่วนเกินจำแนกตามสาเหตุการตาย และ สถานที่เสียชีวิต
                            </Link>
                        </Menu.Item>
                        <Menu.Item class="submenu-bar-item" key="6">
                            <Link to="/graphs&map#graph5" scroll={el => scrollWithOffset(el,loadStatus,5)}>
                                แผนที่การตายส่วนเกิน
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                    <Menu.Item icon={<UserOutlined />} key="7">
                        <Link to="/aboutus">
                            เกี่ยวกับเรา
                        </Link>
                    </Menu.Item>
                    {/* <Menu.Item key="2">
                        <Link to="/view1">
                            View 1
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="3">
                        <Link to="/view2">
                            View 2
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="4">
                        <Link to="/view3">
                            View 3
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="5">
                        <Link to="/view4">
                            View 4
                        </Link>
                    </Menu.Item>
                    <Menu.Item key="6">
                        <Link to="/view5">
                            View 5
                        </Link>
                    </Menu.Item> */}
                </Menu>
                </Header>
                <Content className="site-layout" style={{ padding: '0 30px', marginTop: 64 }}>
                <Switch>
                        <Route exact path="/home">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <p className="dummy-tag">หน้าแรก</p>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/graphs&map">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <Link to="/home">
                                        หน้าแรก
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>กราฟ และ แผนที่</Breadcrumb.Item>
                                {/* <Breadcrumb.Item>
                                    <Link to="/view1">
                                        กราฟที่ 1
                                    </Link>
                                </Breadcrumb.Item> */}
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/view2">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <Link to="/home">
                                        หน้าแรก
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>กราฟ และ แผนที่</Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <Link to="/view2">
                                        กราฟที่ 2
                                    </Link>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/view3">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <Link to="/home">
                                        หน้าแรก
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>กราฟ และ แผนที่</Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <Link to="/view3">
                                        กราฟที่ 3
                                    </Link>
                                    {/* <a href="/view3">
                                        กราฟที่ 3
                                    </a> */}
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/view4">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <Link to="/home">
                                        หน้าแรก
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>กราฟ และ แผนที่</Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <Link to="/view4">
                                        กราฟที่ 4
                                    </Link>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/view5">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <Link to="/home">
                                        หน้าแรก
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>กราฟ และ แผนที่</Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <Link to="/view5">
                                        กราฟที่ 5
                                    </Link>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/aboutus">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <Link to="/home">
                                        หน้าแรก
                                    </Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>
                                    <Link to="/aboutus">
                                        เกี่ยวกับเรา
                                    </Link>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                        <Route exact path="/404">
                            <Breadcrumb style={{ margin: '16px 0' }}>
                                <Breadcrumb.Item>
                                    <a href="/home">หน้าแรก</a>
                                </Breadcrumb.Item>
                            </Breadcrumb>
                        </Route>
                </Switch>
                <div className="site-layout-background" style={{ padding: 24, minHeight: 380 }}>
                    <div className="content">
                        <Switch>
                            <Route exact path = "/home">
                            <Row>
                                <Col span={16}>
                                    <h3 id='home' className="view-title">ติดตามสถานการณ์ผลกระทบจากการระบาดของโรคโควิด-19 ต่อการตายส่วนเพิ่มของประชากร (excess death) </h3>
                                    <hr className="title-line"/>
                                    {getDataState && <p class='dataUpdated'>ข้อมูลอัพเดทล่าสุด สัปดาห์ที่ {latestWeek} เดือน {latestMonth} ปี {latestYear}</p>}
                                    <br/>
                                    <Collapse defaultActiveKey={['1','2','3','4','5']} ghost>
                                        <Panel header="ข้อจำกัดความรับผิดชอบ (Disclaimer)" key="1">
                                            <p class="graph-description">
                                            ข้อมูลนำเสนอเป็นข้อมูลเบื้องต้นที่ได้จากระบบการแจ้งคนเสียชีวิตของทะเบียนราษฎร 
                                            สำนักบริหารการทะเบียน กรมการปกครอง กระทรวงมหาดไทย ซึ่งตัดข้อมูลและประมวลผลทุกวันศุกร์ในแต่ละสัปดาห์
                                            จึงอาจส่งผลต่อความครบถ้วนของข้อมูลจากระยะเวลาที่ล่าช้าในการแจ้งตายได้ ซึ่งอาจมีการเปลี่ยนแปลงได้เมื่อมีการปรับปรุงข้อมูลให้สมบูรณ์ 
                                            ทั้งนี้ ข้อมูลนี้ไม่ใช่สถิติทางการของกระทรวงสาธารณสุข
                                            </p>
                                        </Panel>
                                        <Panel header="การตายส่วนเกิน (excess death) คืออะไร?" key="2">
                                            <p class="graph-description">
                                            ตั้งแต่ต้นปี 2563 - ปัจจุบัน  มีการระบาดของโรคโควิด-19 ที่แพร่กระจายไปทั่วโลกรวมทั้งประเทศไทย 
                                            ซึ่งประกาศสถานการณ์ฉุกเฉินที่ควบคุมการเดินทาง ระหว่าง 26 มีนาคม – 30 เมษายน พ.ศ. 2563 
                                            และจัดตั้งศูนย์บริหารสถานการณ์แพร่ระบาดของโรคติดเชื้อไวรัสโคโรนา 2019 (ศบค.) 
                                            ขึ้นมาซึ่งเป็นหน่วยงานที่รายงานจำนวนผู้เสียชีวิตจากโรคโควิด-19 เป็นรายวัน ทำให้ประชาชนรับทราบจำนวนตายที่เกิดจากโรคโควิค-19 กันอย่างกว้างขวาง  
                                            <br/>
                                            การตายส่วนเกิน “excess deaths” เป็นวิธีการหนึ่งที่ใช้ในการอธิบายถึง 
                                            จํานวนผู้เสียชีวิตในช่วงการระบาดของโรคโควิด-19 
                                            เมื่อเปรียบเทียบกับระดับการเสียชีวิตที่คาดการณ์จากข้อมูลในอดีตหากไม่มีการระบาดของโรคโควิด-19 
                                            เกิดขึ้น excess deathเป็นตัวชี้วัดที่ครอบคลุมและสะท้อนถึงการตายทั้งหมดที่เป็นผลจากสถานการณ์การระบาดทั้งทางตรงจากการตายที่ยืนยันว่าเป็นโรคโควิด-19 
                                            รวมทั้งการตายที่อาจไม่ได้รับการวินิจฉัยและรายงานว่ามาจากโควิด-19 และผลกระทบทางอ้อมจากสาเหตุอื่นๆ ที่เกี่ยวข้องกับภาวะวิกฤตโดยรวม 
                                            เช่น การเข้าถึงการรักษาโรคอื่นๆ ทำได้ยากขึ้นและทำให้เสียโอกาสการรักษา อีกทั้งคนไปโรงพยาบาลน้อยลง จึงอาจส่งผลให้มีผู้เสียชีวิตจากโรคอื่นๆ 
                                            ที่ไม่ใช่โรคโควิด-19 เพิ่มมากขึ้นได้ 
                                            </p>
                                        </Panel>
                                        <br/>
                                        <h2 className="view-subtitle-header">วิธีการคำนวณค่าการตายส่วนเกิน</h2>
                                        <Panel header="การแปลผลค่าการตายส่วนเกิน " key="3">
                                            <p>
                                            <ul>
                                                <li class="list-graph-description">กรณีที่ค่าการตายส่วนเกินมีผลเป็นบวก แสดงว่า การตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิด-19 สูงกว่าค่าสูงสุดของช่วงจำนวนตายที่คาด</li>
                                                <li class="list-graph-description">กรณีที่ค่าการตายส่วนเกินมีผลเป็นศูนย์ แสดงว่า การตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิด-19 อยู่ในช่วงจำนวนตายที่คาด </li>
                                                <li class="list-graph-description">กรณีที่ค่าการตายส่วนเกินมีผลเป็นลบ แสดงว่า การตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิด-19 ต่ำกว่าค่าต่ำสุดของช่วงจำนวนตายที่คาด</li>
                                            </ul>
                                            </p>
                                        </Panel>
                                        <h2 className="view-subtitle-header">จัดทำโดย</h2>
                                        <Panel header="ประมวลผลและวิเคราะห์ข้อมูล" key="4">
                                            <p class="sub-graph-description">
                                                แผนงานพัฒนาดัชนีภาระโรคแห่งประเทศไทย สำนักงานพัฒนานโยบายสุขภาพระหว่างประเทศ  ร่วมกับ 
                                                ภาควิชาวิศวกรรมคอมพิวเตอร์ คณะวิศวกรรมศาสตร์ มหาวิทยาลัยเทคโนโลยีพระจอมเกล้าธนบุรี 
                                            </p>
                                        </Panel>
                                        <Panel header="แหล่งข้อมูล" key="5">
                                            <p class="sub-graph-description">
                                                กองยุทธศาสตร์และแผนงาน สำนักงานปลัดกระทรวงสาธารณสุข กระทรวงสาธารณสุข 
                                                <br/> 
                                                สำนักบริหารการทะเบียน กรมการปกครอง กระทรวงมหาดไทย 
                                            </p>
                                        </Panel>
                                    </Collapse>
                                </Col>
                                <Col span={2}/>
                                <Col span={6}>
                                    <br/>
                                    <Homepage/>
                                </Col>
                            </Row>
                            </Route>
                            <Route exact path="/graphs&map">
                                {/* <h3 id="graph1" className="view-title">การตายส่วนเกินตามเวลา</h3> */}
                                <Card bordered={false} className="filter-container" type="inner" style={{ width: 300, backgroundColor: '#517a38', borderRadius: '50px' }}>
                                    <h3 id='graph1' class="view-title-box">การตายส่วนเกินตามช่วงเวลา</h3>
                                </Card> 
                                {/* <hr className="title-line"/> */}
                                <br/>
                                <p className="graph-description">
                                กราฟ แสดงค่าจำนวน หรือ ร้อยละของการตายส่วนเกินในระดับประเทศ และ ระดับจังหวัดตามช่วงเวลา (รายสัปดาห์ รายเดือน และ รายปี) ในช่วงปีที่มีการระบาดของโรคโควิด-19
                                พ.ศ.2563-ปัจจุบัน โดยเป็นการเปรียบเทียบจำนวนตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิดกับช่วงของจำนวนตายที่คาด (expected Death : upper bound – lower bound) ที่ได้จากค่าเฉลี่ยการตาย 5 ปี (พ.ศ. 2558-2562) 
                                </p>
                                < View_1 />
                                <br/>
                                {/* <h3 id="graph2" className="view-title">การเปรียบเทียบจำนวนตายในช่วงปีที่มีการระบาดของโรคโควิด-19 และ จำนวนตายที่คาดประมาณ</h3> */}
                                <Card bordered={false} className="filter-container" type="inner" style={{ width: 800, backgroundColor: '#517a38', borderRadius: '50px' }}>
                                    <h3 id='graph2' class="view-title-box">การเปรียบเทียบจำนวนตายในช่วงปีที่มีการระบาดของโรคโควิด-19 และ จำนวนตายที่คาดประมาณ</h3>
                                </Card> 
                                {/* <hr className="title-line"/> */}
                                <br/>
                                <p className="graph-description">
                                กราฟ แสดงค่าจำนวนตายที่เกิดขึ้นในช่วงปีที่มีการระบาดของโรคโควิด-19 พ.ศ. 2563 – ปัจจุบัน และ จำนวนตายที่คาด (expected Death) ที่ได้จากค่าเฉลี่ยการตาย 5 ปี (พ.ศ. 2558-2562)  
                                ในระดับประเทศและระดับจังหวัด และตามช่วงเวลา (รายสัปดาห์ รายเดือน และรายปี) 
                                </p>
                                < View_2 />
                                <br/>
                                {/* <h3 id="graph3" className="view-title">การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ</h3> */}
                                <Card bordered={false} className="filter-container" type="inner" style={{ width: 400, backgroundColor: '#517a38', borderRadius: '50px' }}>
                                    <h3 id='graph3' class="view-title-box">การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ</h3>
                                </Card> 
                                {/* <hr className="title-line"/> */}
                                <br/>
                                <p className="graph-description">
                                กราฟ แสดงค่าจำนวนของการตายส่วนเกิน ในระดับประเทศตามช่วงเวลา (รายสัปดาห์ รายเดือน และ รายปี) เพศ และ กลุ่มอายุ ในช่วงปีที่มีการระบาดของโรคโควิด-19 พ.ศ. 2563 – ปัจจุบัน   
                                โดยเป็นการเปรียบเทียบจำนวนตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิด-19 กับช่วงของจำนวนตายที่คาด (expected Death : upper bound – lower bound) ที่ได้จากค่าเฉลี่ยการตาย 5 ปี (พ.ศ. 2558-2562) 
                                </p>    
                                < View_3 />
                                <br/>
                                {/* <h3 id="graph4" className="view-title">การตายส่วนเกินจำแนกตามสาเหตุการตาย และ สถานที่เสียชีวิต</h3> */}
                                <Card bordered={false} className="filter-container" type="inner" style={{ width: 520, backgroundColor: '#517a38', borderRadius: '50px' }}>
                                    <h3 id='graph4' class="view-title-box">การตายส่วนเกินจำแนกตามสาเหตุการตาย และ สถานที่เสียชีวิต</h3>
                                </Card> 
                                {/* <hr className="title-line"/> */}
                                <br/>
                                <p className="graph-description">
                                กราฟ แสดงค่าจำนวนหรือร้อยละของการตายส่วนเกิน ในระดับประเทศและระดับจังหวัด ตามช่วงเวลา (รายสัปดาห์ รายเดือน และรายปี) ตามสาเหตุการตาย  
                                (1 กลุ่มโรคติดเชื้อ,ความผิดปกติในมารดาและปริกำเนิดและ ภาวะโภชนาการบกพร่อง 2 โรคไม่ติดต่อ 3 การบาดเจ็บ 4 ไม่ทราบสาเหตุ) และสถานที่เสียชีวิต (ในสถานพยาบาล หรือ นอกสถานพยาบาล)  
                                ในช่วงปีที่มีการระบาดของโรคโควิด-19 พ.ศ. 2563 – ปัจจุบัน โดยเป็นการเปรียบเทียบจำนวนตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิด-19 กับช่วงของจำนวนตายที่คาด (expected Death : upper bound – lower bound) 
                                ที่ได้จากค่าเฉลี่ยการตาย 5 ปี (พ.ศ. 2558-2562) 
                                </p>  
                                < View_4 />
                                <br/><br/><br/>
                                {/* <h3 id="graph5" className="view-title">แผนที่การตายส่วนเกิน</h3> */}
                                <Card bordered={false} className="filter-container" type="inner" style={{ width: 220, backgroundColor: '#517a38', borderRadius: '50px' }}>
                                    <h3 id='graph5' class="view-title-box">แผนที่การตายส่วนเกิน</h3>
                                </Card> 
                                {/* <hr className="title-line"/> */}
                                <br/>
                                <p className="graph-description">
                                แผนที่ แสดงค่าจำนวนหรือร้อยละของการตายส่วนเกิน ในระดับจังหวัด ตามช่วงเวลา (รายเดือน) ตามสาเหตุการตาย (1 กลุ่มโรคติดเชื้อ,ความผิดปกติในมารดาและปริกำเนิด และ ภาวะโภชนาการบกพร่อง  
                                2 โรคไม่ติดต่อ 3 การบาดเจ็บ 4 ไม่ทราบสาเหตุ) ในช่วงปีที่มีการระบาดของโรคโควิด-19 พ.ศ. 2563 – ปัจจุบัน โดยเป็นการเปรียบเทียบจำนวนตายที่เกิดขึ้นในช่วงที่มีการระบาดของโรคโควิด-19  
                                กับช่วงของจำนวนตายที่คาด (expected Death : upper bound – lower bound) ที่ได้จากค่าเฉลี่ยการตาย 5 ปี (พ.ศ. 2558-2562) 
                                </p>  
                                < View_5 />
                            </Route>
                            {/* <Route exact path="/view2">
                                <h3 className="view-title">กราฟที่ 2 - การตายส่วนเกินเปรียบเทียบกับการตายที่คาดประมาณ </h3>
                                <hr className="title-line"/>
                                <br/>
                                <p className="graph-description">
                                จำนวนผู้เสียชีวิตในห้วงเวลาที่มีการระบาดโรคโควิด-19 (พ.ศ.2563 – ปัจจุบัน) เปรียบเทียบกับค่าคาดประมาณจากห้าปีก่อนหน้า (พ.ศ.2558 - 2562)
                                <br/>
                                กราฟแสดงถึงจำนวนผู้เสียชีวิตในแต่ละช่วงเวลา ในปี พ.ศ.2558 - 2564 เมื่อเทียบกับค่าคาดประมาณ นำเสนอเป็นช่วงเวลา (รายสัปดาห์ และรายเดือน) และพื้นที่ (ระดับประเทศ และระดับจังหวัด)
                                </p>    
                                < View_2 />
                            </Route>
                            <Route exact path="/view3">
                                <h3 className="view-title">กราฟที่ 3 - การตายส่วนเกินจำแนกตามเพศ และ กลุ่มอายุ</h3>
                                <hr className="title-line"/>
                                <br/>
                                <p className="graph-description">
                                การตายส่วนเกินในช่วงเวลาที่มีการระบาดโรคโควิด-19 (พ.ศ.2563 – ปัจจุบัน) เปรียบเทียบกับค่าคาดประมาณจากห้าปีก่อนหน้า (พ.ศ.2558 - 2562)
                                <br/>
                                กราฟแสดงถึงจำนวนผู้เสียชีวิตในแต่ละช่วงเวลา ในปี พ.ศ.2558 - 2564 เมื่อเทียบกับค่าคาดประมาณ นำเสนอเป็นช่วงเวลา (รายสัปดาห์ และรายเดือน) เพศ และกลุ่มอายุ  
                                </p>    
                                < View_3 />
                            </Route>
                            <Route exact path="/view4">
                                <h3 className="view-title">กราฟที่ 4 - การตายส่วนเกินจำแนกตามสาเหตุการตาย และ สถานที่เสียชีวิต</h3>
                                <hr className="title-line"/>
                                <br/>
                                <p className="graph-description">
                                การตายส่วนเกินตามช่วงเวลา (จำนวน/ร้อยละ) จำแนกตามสาเหตุการตาย และสถานที่เสียชีวิต
                                แสดงการตายส่วนเกินตามช่วงเวลา (จำนวน/ร้อยละ) จำแนกตามสาเหตุการเสียชีวิตโดยจัดเป็น 3 กลุ่มที่ระบุสาเหตุการตายได้ คือ กลุ่มโรคติดเชื้อความผิดปกติในมารดาและปริกำเนิดและภาวะโภชนาการบกพร่อง 
                                โรคไม่ติดต่อ และการบาดเจ็บ และกลุ่มที่ไม่สามารถระบุสาเหตุการตายที่ชัดเจน และสถานที่เสียชีวิต (ในสถานพยาบาลและนอกสถานพยาบาล)
                                </p>    
                                < View_4 />
                            </Route>
                            <Route exact path="/view5">
                                <h3 className="view-title">กราฟที่ 5 - แผนที่การตายส่วนเกิน</h3>
                                <hr className="title-line"/>
                                <p className="graph-description">
                                แผนที่รายจังหวัดแสดงการตายส่วนเกินตามช่วงเวลา
                                แสดงการตายส่วนเกิน (จำนวน/ร้อยละ) รายจังหวัดในแต่ละช่วงเวลา
                                </p>    
                                < View_5 />
                            </Route> */}
                            <Route path="/404">
                                <h3 className="view-title">404 Error: ไม่พบหน้าที่ต้องการ</h3>
                                <hr className="title-line"/>
                                <br/>
                                <p className="graph-description">
                                    กรุณาติดต่อผู้ดูแลระบบหากเว็บไซต์นำท่านมายังหน้านี้โดยที่ใช้เมนูด้านบน หรือ พิมพ์ url ที่ถูกต้องแล้ว
                                </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                                <br/><p>            </p>
                            </Route>
                            <Route exact path = "/aboutus">
                            <h3 className="view-title">เกี่ยวกับเรา</h3>
                            <hr className="title-line"/>
                            <br/><br/>
                                <Row>
                                    <Col span={13}>
                                        <img src={map} alt="ihpp map" width={window.innerWidth*screen_width_fac} height={window.innerHeight*screen_height_fac}/>
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span={10}>
                                    <h2 className="credit-subtitle">International Health Policy Program, Thailand</h2>
                                    <p className="graph-description">
                                        Ministry of Public Health, Tiwanon Rd. Nonthaburi 11000, Thailand
                                        <br/>
                                        Tel : +66 (0) 2590 2383
                                        <br/>
                                        Fax : +66 (0) 2590 2380
                                        <br/>
                                        E-mail: bodadmin@ihpp.thaigov.net
                                    </p>  
                                    <br/>
                                    <hr/>
                                    <p className="graph-description">Website design by <a href="http://bigdataexperience.org/">Big Data Experience Center</a></p>
                                    </Col>
                                </Row>
                            </Route>
                            <Route exact path='/' render={() => (
                                <Redirect to="/home" />
                            )}/>
                            <Redirect to="/404" />
                        </Switch>
                    </div>
                </div>
                </Content>
                <Footer style={{ textAlign: 'center' }}>
                    <Row>
                        <Col span={10}>
                            <p className="footer-note">
                                IHPP Excess Death All Right Reserved © 2021 Created by Big Data Experience Center
                            </p>
                        </Col>
                        <Col span={12}>
                        </Col>
                        <Col span={2}>
                            <Link to="/aboutus" className="footer-note-end">ติดต่อกับเรา</Link>
                        </Col>
                    </Row>
                </Footer>
        </Layout>
    </HashRouter>
     );
}
 
export default Home;